import {
  createCategory as publicCreateCategory,
  bulkCreateCategory as publicBulkCreateCategory,
  getCategory as publicGetCategory,
  listCategories as publicListCategories,
  updateCategory as publicUpdateCategory,
  deleteCategory as publicDeleteCategory,
  queryCategories as publicQueryCategories,
  typedQueryCategories as publicTypedQueryCategories,
  bulkAssignCategoriesToProgram as publicBulkAssignCategoriesToProgram,
} from './achievements-categories-v3-category-categories.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  CategoriesQueryBuilder,
  CategoryQuery,
  typedQueryCategories as universalTypedQueryCategories,
} from './achievements-categories-v3-category-categories.universal.js';

function customQueryCategories(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryCategories(httpClient)(),
    typedQueryFunction: (query: CategoryQuery) =>
      publicTypedQueryCategories(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): CategoriesQueryBuilder;
  function overloadedQuery(
    query: CategoryQuery
  ): ReturnType<typeof universalTypedQueryCategories>;
  function overloadedQuery(query?: CategoryQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createCategory: MaybeContext<
  BuildRESTFunction<typeof publicCreateCategory> & typeof publicCreateCategory
> = /*#__PURE__*/ createRESTModule(publicCreateCategory);
export const bulkCreateCategory: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateCategory> &
    typeof publicBulkCreateCategory
> = /*#__PURE__*/ createRESTModule(publicBulkCreateCategory);
export const getCategory: MaybeContext<
  BuildRESTFunction<typeof publicGetCategory> & typeof publicGetCategory
> = /*#__PURE__*/ createRESTModule(publicGetCategory);
export const listCategories: MaybeContext<
  BuildRESTFunction<typeof publicListCategories> & typeof publicListCategories
> = /*#__PURE__*/ createRESTModule(publicListCategories);
export const updateCategory: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCategory> & typeof publicUpdateCategory
> = /*#__PURE__*/ createRESTModule(publicUpdateCategory);
export const deleteCategory: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCategory> & typeof publicDeleteCategory
> = /*#__PURE__*/ createRESTModule(publicDeleteCategory);
export const bulkAssignCategoriesToProgram: MaybeContext<
  BuildRESTFunction<typeof publicBulkAssignCategoriesToProgram> &
    typeof publicBulkAssignCategoriesToProgram
> = /*#__PURE__*/ createRESTModule(publicBulkAssignCategoriesToProgram);
export const queryCategories: MaybeContext<
  BuildRESTFunction<typeof customQueryCategories> & typeof customQueryCategories
> = /*#__PURE__*/ createRESTModule(customQueryCategories);

export {
  SortOrder,
  Action,
  WebhookIdentityType,
} from './achievements-categories-v3-category-categories.universal.js';
export {
  Category,
  ExtendedFields,
  CategoriesAssignedToProgram,
  CategoryAssignedProgramsUpdated,
  CreateCategoryRequest,
  CreateCategoryResponse,
  BulkCreateCategoryRequest,
  BulkCreateCategoryResponse,
  ItemMetadata,
  ApplicationError,
  BulkCategoryResult,
  BulkActionMetadata,
  GetCategoryRequest,
  GetCategoryResponse,
  ListCategoriesRequest,
  ListCategoriesResponse,
  UpdateCategoryRequest,
  UpdateCategoryResponse,
  DeleteCategoryRequest,
  DeleteCategoryResponse,
  QueryCategoriesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryCategoriesResponse,
  CursorPagingMetadata,
  Cursors,
  BulkAssignCategoriesToProgramRequest,
  BulkAssignCategoriesToProgramResponse,
  BulkAssignCategoryResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BulkCreateCategoryOptions,
  ListCategoriesOptions,
  UpdateCategory,
  CategoriesQueryResult,
  CategoriesQueryBuilder,
  CategoryQuerySpec,
  BulkAssignCategoriesToProgramOptions,
} from './achievements-categories-v3-category-categories.universal.js';
export { utils } from './achievements-categories-v3-category-categories.universal.js';
export {
  SortOrderWithLiterals,
  ActionWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  CategoryQuery,
} from './achievements-categories-v3-category-categories.universal.js';
